import React from 'react';
import { WeekChallengeCard } from './week-challenge-card';
import WeekChallengeActivities from './week-challenge-activities';
import { Loader } from '@/components/custom/loader';
// import { EmptyState } from '@/components/custom/empty-state';
import { WeekChallengeCardDuel } from './week-challenge-card-duel';
import { PageContent, Page, PageSidebar } from '@/components/custom/page';
import { CardWrapper } from '@/components/ui/card';

export function WeekChallengeChallenges({ challenges, isLoading }) {
  if (isLoading) return <Loader />;

  return (
    <Page>
      <PageContent>
        {/* {challenges && challenges.length === 0 && (
          <EmptyState
            type="data"
            text={t('emptyState.challengesText')}
          />
        )} */}

        <CardWrapper>
          <WeekChallengeCardDuel />

          {challenges?.map(item => (
            <WeekChallengeCard
              key={item.id}
              challenge={item}
            />
          ))}
        </CardWrapper>
      </PageContent>

      <PageSidebar variant="md">
        <WeekChallengeActivities
          conquers={challenges?.filter(item => item.done)}
          isLoading={isLoading}
        />
      </PageSidebar>
    </Page>
  );
}
